

export const getDialogList = (state) => state?.dialogs?.dialogList || [];